module.exports = __webpack_public_path__ + "img/w3_trash_solid_recover_black.8171db2f.png";